module.exports = __webpack_public_path__ + "img/location-point.5e30eb88.svg";